
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,urlMikrotik,urlAbsensi,conlog,urlSlider,urlBelog } from '@/var/var.js'

Vue.use(VueAxios, axios)

/* 
INI DI GUNAKAN DI COMPOSITION API
JIKA METHOD BIASA PAKAI MIXIN
*/

export default {
    Session(what) {
      var text = null;

      /*
						sessionStorage.setItem('admin', x.data.nama);
						sessionStorage.setItem('wa', x.data.telepon);
						sessionStorage.setItem('username', x.data.username);
						sessionStorage.setItem('subAdminID', x.data.subAdminID); // jika root ini 0
						sessionStorage.setItem('subAdmin', x.data.subAdmin); // jika root ini 0
						sessionStorage.setItem('level', x.data.subAdmin);
						sessionStorage.setItem('myToken', x.data.token);

						if (x.data.tipe != null) {
							sessionStorage.setItem('tipe', x.data.tipe);
						}*/

      if (what == "nama") {
        text = sessionStorage.getItem('admin');
      } else if (what == "token") {
        text = sessionStorage.getItem('myToken');
      } else if (what == "wa") {
        text = sessionStorage.getItem('wa');
      }
      
      return text;
    },
    isCustom() {
      return sessionStorage.getItem('tipe');
    },
    RootOnly() {
      var ijin = true;
      if (sessionStorage.getItem('subAdminID') == 0) {
        ijin = true;
      } else {
        ijin = false;
      }
      
      return ijin;
    },
    ForumAssets() {
      return null; // urlForumAssets;
    },
    getBulanNow() {
      return sessionStorage.getItem('bulanNamaBase');
    },
    getBulan() {
      var bulan = sessionStorage.getItem('bulanIdBase');
      if (sessionStorage.getItem('bulanIdBase') == '0') {
        var d = new Date();
        var n = d.getMonth();
        var bulanx = n + 1;
        if (bulanx < 10) {
          bulanx = "0"+bulanx;
        }
        bulan = bulanx;
      }

      return bulan;
    },
    getTahunNow() {
      return sessionStorage.getItem('tahunBase');
    },
    PPN() {
      return sessionStorage.getItem('PPN');
    },
    isAllow() {
      var allow;
      if (sessionStorage.getItem('level') == "0") {
        allow = true;
      } else {
        allow = false;
      }
      return allow;
    },
    sortAZ (datae,byWithUpperOrNot) {
      var data = datae;
      data.sort(function(a, b) {
        var by;
        if (byWithUpperOrNot.indexOf('-noUpperCase')) {
          var byIsArraySplit = byWithUpperOrNot.split('-');
          by = byIsArraySplit[0];
          if (!isNaN(parseInt(a[by]))) {
            if (true) {
                return (parseInt(a[by]) > parseInt(b[by])) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
            } else {
                return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
            }
          } else {
            if (true) {
                return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
            } else {
                return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
            }
          }
        } else {
          by = byWithUpperOrNot;
          if (!isNaN(parseInt(a[by]))) {
            if (true) {
                return (parseInt(a[by]) > parseInt(b[by])) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
            } else {
                return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
            }
          } else {
            if (true) {
                return (a[by] > b[by].toUpperCase()) ? 1 : ((a[by] < b[by].toUpperCase()) ? -1 : 0);
            } else {
                return (b[by] > a[by].toUpperCase()) ? 1 : ((b[by] < a[by].toUpperCase()) ? -1 : 0);
            }
          }
        }
      });
      return data;
    },
    sortZA (datae,byWithUpperOrNot) {
      var data = datae;
      data.sort(function(a, b) {
        /*
        var by;
        if (byIsArray.indexOf('-')) {
          var byIsArraySplit = byIsArray.split('-');
          if (Array.isArray(byIsArraySplit[0])) {
            console.log("yes array");
            by = byIsArraySplit[0][byIsArraySplit[1]];
          } else {
            by = byIsArraySplit[0]; // JIKA BUKAN ARRAY TERKONTAMINASI -
          }
        } else {
          by = byIsArray;
        }
        */
        var by;
        if (byWithUpperOrNot == "created_at") {
          by = byWithUpperOrNot;
          if (true) {
              return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
          } else {
              return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
          }
        } else {
          if (byWithUpperOrNot.indexOf('-noUpperCase')) {
            var byIsArraySplit = byWithUpperOrNot.split('-');
            by = byIsArraySplit[0];
            if (!isNaN(parseInt(a[by]))) {
              if (true) {
                  return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
              } else {
                  return (parseInt(a[by]) > parseInt(b[by]) ) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
              }
            } else {
                if (true) {
                    return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
                } else {
                    return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
                }
            }

          } else {
            by = byWithUpperOrNot;
            if (!isNaN(parseInt(a[by]))) {
                  if (true) {
                      return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
                  } else {
                      return (parseInt(a[by]) > parseInt(b[by]) ) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
                  }
            } else {
                if (true) {
                    return (b[by].toUpperCase() > a[by].toUpperCase()) ? 1 : ((b[by].toUpperCase() < a[by].toUpperCase()) ? -1 : 0);
                } else {
                    return (a[by].toUpperCase() > b[by].toUpperCase()) ? 1 : ((a[by].toUpperCase() < b[by].toUpperCase()) ? -1 : 0);
                }
            }
          }
        }
      });
      return data;
    },
    isNull(b) {
      var a = 0;
      var x = b;
      if (x == null || x == "") {
        a = 0;
      } else {
        a = x
      }
      return parseInt(a);
    },
    callBot(data,urlx) {
      //console.log(url+"/"+urlx);
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: "http://localhost:8000/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        });            
    },
    call(data,urlx) {
      //console.log(url+"/"+urlx);
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: url+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        });            
    },
    callAbsensi(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: urlAbsensi+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        });            
    },
    callBelog(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: urlBelog+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        });            
    },
    callSlider(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: urlSlider+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        });            
    },
    callMikrotik(data,urlx) {
      /*
      
      var header = {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': "application/json"
      };  

      */

      var header = {};  

      // console.log(urlMikrotik+"/"+urlx);

      return axios({
        method: "POST",
        url: urlMikrotik+"/"+urlx,
        headers: header, 
        data: data
      }).then((response) => {
        return response.data;
      })
      .catch(error => {
        var error = error.response.status;
        //this.error(error);
      });            
    },
    loger(x) {
      if (conlog) {
        console.log(JSON.stringify(x));
      }
    },
    logerNo(x) { // no stringify
      if (conlog) {
        console.log(x);
      }
    },
    ribu(x) {
      var harga = 0;
      try {
        harga = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      catch(err) {
        //
      }

      return 'Rp. '+harga;
    },
    timeNow() {
      const currentTimestamp = Date.now(); 
      const hoursToAddInMs = 7 * 60 * 60 * 1000;
      const newTimestamp = currentTimestamp; // + hoursToAddInMs;
      const newDateFromTimestamp = new Date(newTimestamp);

      return newTimestamp;
      
      //console.log("Original timestamp (ms):", currentTimestamp);
      //console.log("New timestamp (ms):", newTimestamp);
      ///console.log("New date:", newDateFromTimestamp.toISOString());

    },
    cek5menit(time,minute) {
      let minutex = 5;
      if(minute != null) {
        minutex = parseInt(minute);
        //console.log("minute "+minutex)
      }

      const FIVE_MINUTES_IN_MS = minutex * 60 * 1000;
      const storedTimestamp = time;
      const lama = storedTimestamp; 
      //console.log("lama "+lama)

      const currentTime = Date.now();
      //const hoursToAddInMs = 7 * 60 * 60 * 1000;
      
      const baru = currentTime; 
      //console.log("baru "+baru)
      
      //console.log("now "+currentTime);
      const timeDifference = currentTime - storedTimestamp;

      //console.log("Perbedaan waktu" + timeDifference);

      if (timeDifference < FIVE_MINUTES_IN_MS) {

        //console.log("belum "+FIVE_MINUTES_IN_MS+" menit");
        // BELUM 5 MENIT
        return "belum";
      } else {
        
        //console.log("sudah 5 menit");
        // SUDAH 5 MENIT
        return "sudahh";
      }
    },
    newline(x) {
      var harga = x.replace(/(?:\r\n|\r|\n)/g, ' </br> ');
      return harga;
    },
    isNull(x) {
        var a;
        if (x == null || x == "") {
            a = 0;
        } else {
            a = x
        }
        return a;
    },
    tglIndo(date) {       
      if(date == null) {
        return "";
      }
      var bulan = ['Jan', 'Febr', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sept', 'Okt', 'Nov', 'Des'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = tgl.getDate()+' '+bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    BulanOnly(date) {      
      var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    jamIndo(jam) {
      let realjam = "-";
      try {
        realjam = jam.slice(0, -3);
      } catch (error) {
        
      }
      return realjam;
    }
}


// WEBPACK FOOTER //
// ./src/globalFunc/myGlobal.js